/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
// TODO: remove code above and fix issues in case changing this file
'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileContacts', cobCarrierProfileContacts);

	cobCarrierProfileContacts.$inject = [
		'$timeout', 'sessionService', 'subjectObserverMessagesService',
		'observerService', 'carrierRegistrationService', 'validationService', '$stateParams'
	];

	var $timeout,
		sessionService,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		subjectMessages,
		observerMessages,
		hasPrimary,
		validationService,
		$stateParams;


	function cobCarrierProfileContacts(_$timeout_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_validationService_,
		_$stateParams_) {
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		validationService = _validationService_;
		$stateParams = _$stateParams_;

		hasPrimary = false;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileContacts.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.carrierId = $stateParams.carrierId;

			scope.contactNameTypeAheadFilter = contactNameTypeAheadFilter;
			scope.contactNameTypeAheadSelect = contactNameTypeAheadSelect;
			scope.contactNameChange = contactNameChange;
			scope.contactNameBlur = contactNameBlur;
			scope.contactNameFocus = contactNameFocus;
			scope.contactPrimaryDisable = contactPrimaryDisable;

			scope.contactAddEditClick = contactAddEditClick;
			scope.contactCancelClick = contactCancelClick;
			scope.saveContact = saveContact;
			scope.deleteContact = deleteContact;
			scope.contactDeleteConfirm = contactDeleteConfirm;
			scope.contactDeleteCancel = contactDeleteCancel;

			scope.saveReference = saveReference;
			scope.deleteReference = deleteReference;
			scope.referenceCancelClick = referenceCancelClick;
			scope.referenceAddEditClick = referenceAddEditClick;

			scope.validateContactCompany = validateContactCompany;
			scope.validateContactName = validateContactName;
			scope.validateContactPhoneNumber = validateContactPhoneNumber;
			scope.validateContactFaxNumber = validateContactFaxNumber;
			scope.validateContactEmail = validateContactEmail;

			scope.setIsDirtyContacts = setIsDirtyContacts;
			scope.setIsDirtyReferences = setIsDirtyReferences;
			scope.goToTab = goToTab;
			scope.onForceGo = onForceGo;

			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				contacts: [
					{
						displayRole: 'Owner/Officer',
						id: 'owner',
						role: 'Owner or Officer',
						validation: {}
					},
					{
						displayRole: 'Accounting',
						id: 'accounting',
						role: 'Accounting',
						validation: {}
					},
					{
						displayRole: 'Dispatch & Operations',
						id: 'dispatch',
						role: 'Dispatch and Operations',
						validation: {}
					},
					{
						displayRole: 'Safety & Claims',
						id: 'safety',
						role: 'Safety and Claims',
						validation: {}
					},
					{
						displayRole: 'After Hours & Emergency',
						id: 'emergency',
						role: 'After Hours and Emergency',
						validation: {}
					}
				],

				reference1: {
					validation: {}
				},
				reference2: {
					validation: {}
				},
				reference3: {
					validation: {}
				},

				typeAheadFilter: [],

				editContact: false,
				editReference: false
			};

			scope.contactToDelete = {};
			loadData(false);
			registerObserverHandlers();
			document.title = 'Profile-Contacts';

		}

		function loadData(skipSendLoad) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_WAITING);

			carrierRegistrationService.lookupContactsReferences(scope.carrierId)
				.then(function(response) {
					hasPrimary = false;
					if (!scope.m.editContact) //do not reload contacts well they are being edited
					{
						scope.m.isDirtyContacts = false;
						if (!scope.m.isDirtyReferences) {
							setSectionMessage(false);
							window.onbeforeunload = undefined;
						}

						angular.forEach(response.data.contacts,
							function(contact) {

								if (contact.isPrimary) {
									hasPrimary = true;
								}
								switch (contact.role) {
								case 'Owner or Officer':
									scope.m.contacts[0].isPrimary = contact.isPrimary;
									scope.m.contacts[0].name = contact.name;
									scope.m.contacts[0].title = contact.title;
									scope.m.contacts[0].phoneNumber = contact.phone;
									scope.m.contacts[0].phoneExtension = contact.phoneExtension;
									scope.m.contacts[0].faxNumber = contact.fax;
									scope.m.contacts[0].email = contact.email;
									scope.m.contacts[0].edit = false;
									break;
								case 'Accounting':
									scope.m.contacts[1].isPrimary = contact.isPrimary;
									scope.m.contacts[1].name = contact.name;
									scope.m.contacts[1].title = contact.title;
									scope.m.contacts[1].phoneNumber = contact.phone;
									scope.m.contacts[1].phoneExtension = contact.phoneExtension;
									scope.m.contacts[1].faxNumber = contact.fax;
									scope.m.contacts[1].email = contact.email;
									scope.m.contacts[1].edit = false;
									break;
								case 'Dispatch and Operations':
									scope.m.contacts[2].isPrimary = contact.isPrimary;
									scope.m.contacts[2].name = contact.name;
									scope.m.contacts[2].title = contact.title;
									scope.m.contacts[2].phoneNumber = contact.phone;
									scope.m.contacts[2].phoneExtension = contact.phoneExtension;
									scope.m.contacts[2].faxNumber = contact.fax;
									scope.m.contacts[2].email = contact.email;
									scope.m.contacts[2].edit = false;
									break;
								case 'Safety and Claims':
									scope.m.contacts[3].isPrimary = contact.isPrimary;
									scope.m.contacts[3].name = contact.name;
									scope.m.contacts[3].title = contact.title;
									scope.m.contacts[3].phoneNumber = contact.phone;
									scope.m.contacts[3].phoneExtension = contact.phoneExtension;
									scope.m.contacts[3].faxNumber = contact.fax;
									scope.m.contacts[3].email = contact.email;
									scope.m.contacts[3].edit = false;
									break;
								case 'After Hours and Emergency':
									scope.m.contacts[4].isPrimary = contact.isPrimary;
									scope.m.contacts[4].name = contact.name;
									scope.m.contacts[4].title = contact.title;
									scope.m.contacts[4].phoneNumber = contact.phone;
									scope.m.contacts[4].phoneExtension = contact.phoneExtension;
									scope.m.contacts[4].faxNumber = contact.fax;
									scope.m.contacts[4].email = contact.email;
									scope.m.contacts[4].edit = false;
									break;
								}
							});
					}
					if (!scope.m.editReference) //do not reload references well they are being edited
					{
						if (!scope.m.isDirtyContacts) {
							setSectionMessage(false);
							window.onbeforeunload = undefined;
						}

						resetReferences();
						angular.forEach(response.data.references,
							function(reference, index) {
								if (index === 0) {
									scope.m.reference1.companyName = reference.companyName;
									scope.m.reference1.name = reference.contactName;
									scope.m.reference1.phoneNumber = reference.phone;
									scope.m.reference1.phoneExtension = reference.phoneExtension;
									scope.m.reference1.referenceIndex = reference.referenceIndex;
								}
								if (index === 1) {
									scope.m.reference2.companyName = reference.companyName;
									scope.m.reference2.name = reference.contactName;
									scope.m.reference2.phoneNumber = reference.phone;
									scope.m.reference2.phoneExtension = reference.phoneExtension;
									scope.m.reference2.referenceIndex = reference.referenceIndex;
								}
								if (index === 2) {
									scope.m.reference3.companyName = reference.companyName;
									scope.m.reference3.name = reference.contactName;
									scope.m.reference3.phoneNumber = reference.phone;
									scope.m.reference3.phoneExtension = reference.phoneExtension;
									scope.m.reference3.referenceIndex = reference.referenceIndex;
								}
							});
					}
				})
				.finally(function() {
					observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_DONE);
					if (skipSendLoad)
						return;
					$timeout(function () {
						observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
					}, 0);
				});
		}

		function resetReferences() {
			scope.m.isDirtyReferences = false;
			scope.m.reference1.companyName = undefined;
			scope.m.reference1.name = undefined;
			scope.m.reference1.phoneNumber = undefined;
			scope.m.reference1.phoneExtension = undefined;
			scope.m.reference1.referenceIndex = undefined;

			scope.m.reference2.companyName = undefined;
			scope.m.reference2.name = undefined;
			scope.m.reference2.phoneNumber = undefined;
			scope.m.reference2.phoneExtension = undefined;
			scope.m.reference2.referenceIndex = undefined;

			scope.m.reference3.companyName = undefined;
			scope.m.reference3.name = undefined;
			scope.m.reference3.phoneNumber = undefined;
			scope.m.reference3.phoneExtension = undefined;
			scope.m.reference3.referenceIndex = undefined;
		}

		function registerObserverHandlers() {

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirtyReferences || scope.m.isDirtyContacts) {
						if (!
						confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
							event.preventDefault();
						}
					}
				});

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);
		}

		function setIsDirtyContacts() {
			scope.m.isDirtyContacts = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function setIsDirtyReferences() {
			scope.m.isDirtyReferences = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function saveData(callback) {
			if (scope.m.isDirtyContacts) {
				saveContacts(callback);
			}
			if (scope.m.isDirtyReferences) {
				saveReferences(callback);
			}
			if (!scope.m.isDirtyContacts && !scope.m.isDirtyReferences) {
				if (typeof (callback) === 'function') {
					callback();
				}
			}
		}

		function saveContacts(callback) {
			if (hasContact()) {
				saveContact(scope.m.contacts[0], callback);
				saveContact(scope.m.contacts[1], callback);
				saveContact(scope.m.contacts[2], callback);
				saveContact(scope.m.contacts[3], callback);
				saveContact(scope.m.contacts[4], callback);
			} else {
				scope.m.showContactRequired = true;
				setSectionMessage(true);

				if (typeof (callback) === 'function') {
					scope.pendingCallback = callback;
				}
			}
		}

		function saveReferences(callback) {
			saveReference(scope.m.reference1, callback);
			saveReference(scope.m.reference2, callback);
			saveReference(scope.m.reference3, callback);
		}

		function hasContact() {
			return (scope.m.contacts[0].name ||
                scope.m.contacts[1].name ||
                scope.m.contacts[2].name ||
                scope.m.contacts[3].name ||
                scope.m.contacts[4].name);
		}

		function contactNameTypeAheadFilter(value) {
			var filterResults = [];
			if (!value)
				return filterResults;
			var string = value.toLowerCase();
			if (scope.m.contacts[0].name) {
				if (scope.m.contacts[0].edit) {
					if (scope.m.ownerOfficerClean &&
                        scope.m.ownerOfficerClean.name &&
                        scope.m.ownerOfficerClean.name.toLowerCase().indexOf(string) > -1) {
						filterResults.push(scope.m.ownerOfficerClean.name);
					}
				} else if (scope.m.contacts[0].name.toLowerCase().indexOf(string) > -1) {
					filterResults.push(scope.m.contacts[0].name);
				}
			}
			if (scope.m.contacts[1].name) {
				if (scope.m.contacts[1].edit) {
					if (scope.m.accountingClean &&
                        scope.m.accountingClean.name &&
                        scope.m.accountingClean.name.toLowerCase().indexOf(string) > -1) {
						if (filterResults.indexOf(scope.m.accountingClean.name) > -1) { /** non unique} **/
						} else
							filterResults.push(scope.m.accountingClean.name);
					}
				} else if (scope.m.contacts[1].name.toLowerCase().indexOf(string) > -1) {
					if (filterResults.indexOf(scope.m.contacts[1].name) > -1) { /** non unique} **/
					} else
						filterResults.push(scope.m.contacts[1].name);
				}
			}
			if (scope.m.contacts[2].name) {
				if (scope.m.contacts[2].edit) {
					if (scope.m.dispatchOperationsClean &&
                        scope.m.dispatchOperationsClean.name &&
                        scope.m.dispatchOperationsClean.toLowerCase().name.indexOf(string) > -1) {
						if (filterResults.indexOf(scope.m.dispatchOperationsClean.name) > -1) { /** non unique} **/
						} else
							filterResults.push(scope.m.dispatchOperationsClean.name);
					}
				} else if (scope.m.contacts[2].name.toLowerCase().indexOf(string) > -1) {
					if (filterResults.indexOf(scope.m.contacts[2].name) > -1) { /** non unique} **/
					} else
						filterResults.push(scope.m.contacts[2].name);
				}
			}
			if (scope.m.contacts[3].name) {
				if (scope.m.contacts[3].edit) {
					if (scope.m.saftyClaimsClean &&
                        scope.m.saftyClaimsClean.name &&
                        scope.m.saftyClaimsClean.name.toLowerCase().indexOf(string) > -1) {
						if (filterResults.indexOf(scope.m.saftyClaimsClean.name) > -1) { /** non unique} **/
						} else
							filterResults.push(scope.m.saftyClaimsClean.name);
					}
				} else if (scope.m.contacts[3].name.toLowerCase().indexOf(string) > -1) {
					if (filterResults.indexOf(scope.m.contacts[3].name) > -1) { /** non unique} **/
					} else
						filterResults.push(scope.m.contacts[3].name);
				}
			}
			if (scope.m.contacts[4].name) {
				if (scope.m.contacts[4].edit) {
					if (scope.m.afterHoursEmergencyClean &&
                        scope.m.afterHoursEmergencyClean.name &&
                        scope.m.afterHoursEmergencyClean.name.toLowerCase().indexOf(string) > -1) {
						if (filterResults.indexOf(scope.m.afterHoursEmergencyClean.name) > -1) { /** non unique} **/
						} else
							filterResults.push(scope.m.afterHoursEmergencyClean.name);
					}
				} else if (scope.m.contacts[4].name.toLowerCase().indexOf(string) > -1) {
					if (filterResults.indexOf(scope.m.contacts[4].name) > -1) { /** non unique} **/
					} else
						filterResults.push(scope.m.contacts[4].name);
				}
			}

			return filterResults;
		}

		function contactNameTypeAheadSelect(name, contact) {
			if (!name) {
				return;
			}
			scope.m.contacts[index].showTypeAhead = false;

			if (scope.m.contacts[0].name === name) {
				scope.m.contacts[index].name = scope.m.contacts[0].name;
				scope.m.contacts[index].title = scope.m.contacts[0].title;
				scope.m.contacts[index].phoneNumber = scope.m.contacts[0].phoneNumber;
				scope.m.contacts[index].phoneExtension = scope.m.contacts[0].phoneExtension;
				scope.m.contacts[index].faxNumber = scope.m.contacts[0].faxNumber;
				scope.m.contacts[index].email = scope.m.contacts[0].email;

				return;
			}
			if (scope.m.contacts[1].name === name) {
				scope.m.contacts[index].name = scope.m.contacts[1].name;
				scope.m.contacts[index].title = scope.m.contacts[1].title;
				scope.m.contacts[index].phoneNumber = scope.m.contacts[1].phoneNumber;
				scope.m.contacts[index].phoneExtension = scope.m.contacts[1].phoneExtension;
				scope.m.contacts[index].faxNumber = scope.m.contacts[1].faxNumber;
				scope.m.contacts[index].email = scope.m.contacts[1].email;

				return;
			}
			if (scope.m.contacts[2].name === name) {
				scope.m.contacts[index].name = scope.m.contacts[2].name;
				scope.m.contacts[index].title = scope.m.contacts[2].title;
				scope.m.contacts[index].phoneNumber = scope.m.contacts[2].phoneNumber;
				scope.m.contacts[index].phoneExtension = scope.m.contacts[2].phoneExtension;
				scope.m.contacts[index].faxNumber = scope.m.contacts[2].faxNumber;
				scope.m.contacts[index].email = scope.m.contacts[2].email;

				return;
			}
			if (scope.m.contacts[3].name) {
				scope.m.contacts[index].name = scope.m.contacts[3].name;
				scope.m.contacts[index].title = scope.m.contacts[3].title;
				scope.m.contacts[index].phoneNumber = scope.m.contacts[3].phoneNumber;
				scope.m.contacts[index].phoneExtension = scope.m.contacts[3].phoneExtension;
				scope.m.contacts[index].faxNumber = scope.m.contacts[3].faxNumber;
				scope.m.contacts[index].email = scope.m.contacts[3].email;

				return;
			}
			if (scope.m.contacts[4].name) {
				scope.m.contacts[index].name = scope.m.contacts[4].name;
				scope.m.contacts[index].title = scope.m.contacts[4].title;
				scope.m.contacts[index].phoneNumber = scope.m.contacts[4].phoneNumber;
				scope.m.contacts[index].phoneExtension = scope.m.contacts[4].phoneExtension;
				scope.m.contacts[index].faxNumber = scope.m.contacts[4].faxNumber;
				scope.m.contacts[index].email = scope.m.contacts[4].email;

				return;
			}
		}

		function contactNameChange(index) {
			if (scope.contactNameBlurTimer) {
				$timeout.cancel(scope.contactNameBlurTimer);
			}
			if (scope.m.contacts[index].name)
				scope.m.contacts[index].showTypeAhead = true;
			else
				scope.m.contacts[index].showTypeAhead = false;
		}

		function contactNameBlur(index) {
			validateContactName(index);

			scope.contactNameBlurTimer = $timeout(function() {
				scope.m.contacts[index].showTypeAhead = false;
			},
			200);
		}

		function contactNameFocus(event) {
			event.currentTarget.parentElement.children[0].focus();
		}

		function contactPrimaryDisable(index) {
			if (scope.m.contacts[index].edit) {
				if (!scope.m.contacts[index].clean.isPrimary && hasPrimary) {
					return false;
				} else {
					return true;
				}
			} else
				return true;
		}

		function saveContact(index, callback) {
			if (!scope.m.contacts[index].edit) //if it is clean don't resave
				return;
			if (validateContact(index)) {
				var action;
				if (scope.m.contacts[index].clean && scope.m.contacts[index].clean.name) {
					action = 'EDIT';
				} else {
					action = 'ADD';
				}

				carrierRegistrationService.updateCarrierContact(action,
					scope.m.contacts[index].name,
					scope.m.contacts[index].role,
					scope.m.contacts[index].title,
					scope.m.contacts[index].phoneNumber,
					scope.m.contacts[index].phoneExtension,
					scope.m.contacts[index].faxNumber,
					scope.m.contacts[index].email,
					scope.m.contacts[index].isPrimary,
					scope.carrierId)
					.then(function() {
						scope.m.editContact = false;
						scope.m.showContactRequired = false;
						observerService.sendMessageToSubject(scope,
							subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
							'contacts');

						if (typeof (callback) === 'function') {
							if (!scope.m.editReference) //wait for references to save
								callback();
						} else {
							loadData(true);
						}
					});
			} else if (typeof (callback) === 'function') {
				setSectionMessage(true);
				scope.pendingCallback = callback;
			}
		}

		function contactCancelClick(index) {
			scope.m.contacts[index].isPrimary = scope.m.contacts[index].clean.isPrimary;
			scope.m.contacts[index].name = scope.m.contacts[index].clean.name;
			scope.m.contacts[index].title = scope.m.contacts[index].clean.title;
			scope.m.contacts[index].phoneNumber = scope.m.contacts[index].clean.phoneNumber;
			scope.m.contacts[index].phoneExtension = scope.m.contacts[index].clean.phoneExtension;
			scope.m.contacts[index].faxNumber = scope.m.contacts[index].clean.faxNumber;
			scope.m.contacts[index].email = scope.m.contacts[index].clean.email;
			scope.m.contacts[index].edit = false;

			delete scope.m.contacts[index].validation.name;
			delete scope.m.contacts[index].validation.phoneNumber;
			delete scope.m.contacts[index].validation.faxNumber;
			delete scope.m.contacts[index].validation.email;

			scope.m.editContact = false;
			scope.m.isDirtyContacts = false;
			if (!scope.m.isDirtyReferences) {
				setSectionMessage(false);
			}
		}

		function contactAddEditClick(index) {

			scope.m.editContact = true;

			$timeout(function() { scope.m.contacts[index].edit = true; }, 1);


			scope.m.contacts[index].clean = {
				isPrimary: scope.m.contacts[index].isPrimary,
				name: scope.m.contacts[index].name,
				title: scope.m.contacts[index].title,
				phoneNumber: scope.m.contacts[index].phoneNumber,
				phoneExtension: scope.m.contacts[index].phoneExtension,
				faxNumber: scope.m.contacts[index].faxNumber,
				email: scope.m.contacts[index].email
			};
			if (!hasPrimary) {
				scope.m.contacts[index].isPrimary = true;
			}
		}

		function deleteContact(index) {
			scope.contactToDelete = scope.m.contacts[index];
			scope.m.showContactDeleteConfimation = true;
		}

		function contactDeleteConfirm() {
			carrierRegistrationService.updateCarrierContact('DELETE',
				scope.contactToDelete.name,
				scope.contactToDelete.role,
				scope.contactToDelete.title,
				scope.contactToDelete.phoneNumber,
				scope.contactToDelete.phoneExtension,
				scope.contactToDelete.faxNumber,
				scope.contactToDelete.email,
				scope.contactToDelete.isPrimary,
				scope.carrierId)
				.then(function() {
					scope.contactToDelete.name = undefined;
					scope.contactToDelete.title = undefined;
					scope.contactToDelete.phoneNumber = undefined;
					scope.contactToDelete.phoneExtension = undefined;
					scope.contactToDelete.faxNumber = undefined;
					scope.contactToDelete.email = undefined;
					scope.contactToDelete.edit = false;

					scope.m.showContactDeleteConfimation = false;
					loadData(true);
				});

		}

		function contactDeleteCancel() {
			scope.m.showContactDeleteConfimation = false;
		}

		function saveReference(reference, callback) {
			if (!reference.edit) //if it is clean don't resave
				return;
			if (validateReference(reference)) {
				var action;
				if (reference && reference.clean && reference.clean.name) {
					action = 'EDIT';
				} else {
					action = 'ADD';
				}

				carrierRegistrationService.updateCarrierReferences(reference.referenceIndex,
					action,
					reference.companyName,
					reference.name,
					reference.phoneNumber,
					reference.phoneExtension,
					scope.carrierId)
					.then(function() {
						scope.m.editReference = false;
						reference.edit = false;

						if (typeof (callback) === 'function') {
							if (!scope.m.editContact) //wait for contacts to save
								callback();
						} else {
							loadData(true);
						}
					});
			} else if (typeof (callback) === 'function') {
				setSectionMessage(true);
				scope.pendingCallback = callback;
			}
		}

		function deleteReference(reference) {
			carrierRegistrationService.updateCarrierReferences(reference.referenceIndex,
				'DELETE',
				reference.companyName,
				reference.name,
				reference.phoneNumber,
				reference.phoneExtension,
				scope.carrierId)
				.then(function() {

					reference.companyName = undefined;
					reference.name = undefined;
					reference.phoneNumber = undefined;
					reference.phoneExtension = undefined;
					reference.edit = false;

					loadData(true);
				});
		}

		function referenceCancelClick(reference) {
			reference.companyName = reference.clean.companyName;
			reference.name = reference.clean.name;
			reference.phoneNumber = reference.clean.phoneNumber;
			reference.phoneExtension = reference.clean.phoneExtension;
			reference.edit = false;

			delete reference.validation.companyName;
			delete reference.validation.name;
			delete reference.validation.phoneNumber;
			delete reference.validation.faxNumber;

			scope.m.editReference = false;
			scope.m.isDirtyReferences = false;
			if (!scope.m.isDirtyContacts) {
				setSectionMessage(false);
			}
		}

		function referenceAddEditClick(reference) {
			scope.m.editReference = true;
			reference.edit = true;

			reference.clean = {
				companyName: reference.companyName,
				name: reference.name,
				phoneNumber: reference.phoneNumber,
				phoneExtension: reference.phoneExtension
			};
		}

		function validateContact(index) {

			if (scope.m.contacts[index].edit) {
				validateContactName(index);
				validateContactPhoneNumber(index);
				validateContactFaxNumber(index);
				validateContactEmail(index);
			}

			return Object.keys(scope.m.contacts[index].validation).length === 0;
		}

		function validateReference(reference) {
			if (reference.edit) {
				validateContactCompany(reference);
				validateContactName(reference);
				validateContactPhoneNumber(reference);
			}

			return Object.keys(reference.validation).length === 0;
		}

		function validateContactCompany(index) {
			if (typeof index === 'object') {
				if (!index.companyName) {
					index.validation.companyName = 'Input is required';
				} else {
					delete index.validation.companyName;
				}
			} else {
				if (!scope.m.contacts[index].companyName) {
					scope.m.contacts[index].validation.companyName = 'Input is required';
				} else {
					delete scope.m.contacts[index].validation.companyName;
				} 
			}
            
		}

		function validateContactName(index) {
			if (typeof index === 'object') {
				if (index.name) {
					if (index.name.length > 40) {
						index.validation.name = 'Valid input is required';
					}

					delete index.validation.name;
				} else {
					index.validation.name = 'Input is required';
				}
			} else {
				if (scope.m.contacts[index].name) {
					if (scope.m.contacts[index].name.length > 40) {
						scope.m.contacts[index].validation.name = 'Valid input is required';
					}

					delete scope.m.contacts[index].validation.name;
				} else {
					scope.m.contacts[index].validation.name = 'Input is required';
				}
			}
		}

		function validateContactPhoneNumber(index) {
			if (typeof index === 'object') {
				if (!index.phoneNumber) {
					index.validation.phoneNumber = 'Input is required';
				} else if (index.phoneNumber.length !== 10) {
					index.validation.phoneNumber = 'Valid input is required';
				} else if (index.phoneNumber[0] === '0' || index.phoneNumber[0] === '1') {
					index.validation.phoneNumber = 'Valid input is required';
				} else {
					delete index.validation.phoneNumber;
				}
			} else {
				if (!scope.m.contacts[index].phoneNumber) {
					scope.m.contacts[index].validation.phoneNumber = 'Input is required';
				} else if (scope.m.contacts[index].phoneNumber.length !== 10) {
					scope.m.contacts[index].validation.phoneNumber = 'Valid input is required';
				} else if (scope.m.contacts[index].phoneNumber[0] === '0' || scope.m.contacts[index].phoneNumber[0] === '1') {
					scope.m.contacts[index].validation.phoneNumber = 'Valid input is required';
				} else {
					delete scope.m.contacts[index].validation.phoneNumber;
				}
			}
		}

		function validateContactFaxNumber(index) {
			if (scope.m.contacts[index].faxNumber && scope.m.contacts[index].faxNumber.length !== 10) {
				scope.m.contacts[index].validation.faxNumber = 'Valid input is required';
			} else if (scope.m.contacts[index].faxNumber && (scope.m.contacts[index].faxNumber[0] === '0' || scope.m.contacts[index].faxNumber[0] === '1')) {
				scope.m.contacts[index].validation.faxNumber = 'Valid input is required';
			} else {
				delete scope.m.contacts[index].validation.faxNumber;
			}
		}

		function validateContactEmail(index) {
			if (scope.m.contacts[index].email &&
                !/^([a-zA-Z0-9])([a-zA-Z0-9_\.\-])*([a-zA-Z0-9])\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,4})+$/.test(scope.m.contacts[index].email)) {
				scope.m.contacts[index].validation.email = 'Valid email is required';
			} else {
				delete scope.m.contacts[index].validation.email;
			}
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function setSectionMessage(show) {
			scope.m.showSectionMessage = show;
			if (show) {
				$timeout(function() {
					$('.carrier-profile-wrapper')
						.animate({
							scrollTop: $('#error-summary').offset().top
						},
						200);
				},
				10);
			}
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}
	}

})();
